import React, { FC, ReactNode } from 'react'

import { ContentStack, ContentStackProps } from '../../layout/ContentStack'
import { SubHeading, Body } from '../../typography/Text'

export type InfoMessage = {
  summary: ReactNode
  description?: ReactNode
}

export type InfoMessageBoxProps = Omit<ContentStackProps, 'children'> &
  InfoMessage

export const InfoMessageBox: FC<InfoMessageBoxProps> = ({
  summary,
  description,
  ...props
}) => {
  return (
    <ContentStack layerStyle="success" p="md" {...props}>
      <SubHeading>{summary}</SubHeading>
      {description ? <Body>{description}</Body> : null}
    </ContentStack>
  )
}
